/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_CanceledInputs */

const en_admin_external_booking_edit_canceled = /** @type {(inputs: Admin_External_Booking_Edit_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled`)
};

/** @type {(inputs: Admin_External_Booking_Edit_CanceledInputs) => LocalizedString} */
const de_admin_external_booking_edit_canceled = en_admin_external_booking_edit_canceled;

/** @type {(inputs: Admin_External_Booking_Edit_CanceledInputs) => LocalizedString} */
const es_admin_external_booking_edit_canceled = en_admin_external_booking_edit_canceled;

/** @type {(inputs: Admin_External_Booking_Edit_CanceledInputs) => LocalizedString} */
const fr_admin_external_booking_edit_canceled = en_admin_external_booking_edit_canceled;

/** @type {(inputs: Admin_External_Booking_Edit_CanceledInputs) => LocalizedString} */
const it_admin_external_booking_edit_canceled = en_admin_external_booking_edit_canceled;

/** @type {(inputs: Admin_External_Booking_Edit_CanceledInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_canceled = en_admin_external_booking_edit_canceled;

/** @type {(inputs: Admin_External_Booking_Edit_CanceledInputs) => LocalizedString} */
const pl_admin_external_booking_edit_canceled = en_admin_external_booking_edit_canceled;

/** @type {(inputs: Admin_External_Booking_Edit_CanceledInputs) => LocalizedString} */
const hu_admin_external_booking_edit_canceled = en_admin_external_booking_edit_canceled;

/** @type {(inputs: Admin_External_Booking_Edit_CanceledInputs) => LocalizedString} */
const ro_admin_external_booking_edit_canceled = en_admin_external_booking_edit_canceled;

/**
* | output |
* | --- |
* | "Canceled" |
*
* @param {Admin_External_Booking_Edit_CanceledInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_canceled = /** @type {((inputs?: Admin_External_Booking_Edit_CanceledInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_CanceledInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_canceled(inputs)
	if (locale === "de") return de_admin_external_booking_edit_canceled(inputs)
	if (locale === "es") return es_admin_external_booking_edit_canceled(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_canceled(inputs)
	if (locale === "it") return it_admin_external_booking_edit_canceled(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_canceled(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_canceled(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_canceled(inputs)
	return ro_admin_external_booking_edit_canceled(inputs)
});
export { admin_external_booking_edit_canceled as "admin.external_booking_edit.canceled" }